class ResetFrameFinder extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const resetBtn = this.querySelector('[data-reset="reset"]');
        if (resetBtn) {
            resetBtn.addEventListener('click', (event) => {
                event.preventDefault();
                this.handleReset();
            });
        }
    }


    /**
     * Handles the reset request for the frame finder
     */
    handleReset() {
        const collectionUrl = this.dataset.collection;
        if (!collectionUrl) return;

        localStorage.clear();
        CookieUtils.deleteCookie(FRAME_FINDER_KEYS.filteredUrlKey);

        window.location.href = collectionUrl;
    }
}


customElements.define('frame-finder-reset', ResetFrameFinder);